import { IconPlus } from "@tabler/icons-react";
import clsx from "clsx";
import Button from "components/Button";
import { useTranslation } from "react-i18next";

interface RulesHeaderProps {
  onAdd: () => void;
  showShadow?: boolean;
}

function RulesHeader({ onAdd, ...props }: RulesHeaderProps) {
  const { t } = useTranslation();

  return (
    <div
      className={clsx("flex items-center justify-between px-6 py-3 gap-6", {
        "shadow-md": props.showShadow,
      })}
    >
      <div>
        <div className="font-semibold text-base mb-2">
          {t("rulesEditor.rules")}
        </div>
        <div className="text-xs font-normal text-gray-600">
          {t("rulesEditor.rulesDescription")}
        </div>
      </div>
      <Button
        type="secondary"
        size="small"
        leadingIcon={<IconPlus size={16} stroke={3} />}
        width="fit-content"
        className="!h-6 font-semibold whitespace-nowrap"
        onClick={onAdd}
      >
        {t("rulesEditor.addRule")}
      </Button>
    </div>
  );
}

export default RulesHeader;
